// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sB-z","smallCardRow":"tB-z","largeCardRow":"uB-z","productSearchRow":"vB-z","curatedRow":"wB-z"};